import { MyAddresses } from 'feature/addresses/MyAddresses'
import { MainLayout } from 'layouts'

export function MyAddressesPage() {
  return (
    <MainLayout>
      <div className='container'>
        <MyAddresses />
      </div>
    </MainLayout>
  )
}
